export const DMS_MODULE = 'Sklady';
export const CRUMB_LABEL_KEY = 'grdInventura';
export const NAME = 'Inventura';
